import { render, staticRenderFns } from "./urgentRecord.vue?vue&type=template&id=03adf5e2&scoped=true&"
import script from "./urgentRecord.vue?vue&type=script&lang=js&"
export * from "./urgentRecord.vue?vue&type=script&lang=js&"
import style0 from "./urgentRecord.vue?vue&type=style&index=0&id=03adf5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03adf5e2",
  null
  
)

export default component.exports